import React from "react";
import {matchPath} from "react-router-dom";
import i18n from "../../i18n";
import parse from "html-react-parser";
import { NL, GB, DE, FR } from 'country-flag-icons/react/3x2'

export function splitCurrentPathIntoSegments(currentPathname)
{
    const trimmedPathname = currentPathname.replace(/^\/|\/$/g, ''); // Remove leading and trailing slashes
    //   console.log("trimmed:"+trimmedPathname);
    return trimmedPathname.split('/'); // Split the pathname into segments
}

export function generateLanguageLink(languageCode, currentPathname) {


// console.log("currentPathname:"+currentPathname);

    const basePath = getBasePath(currentPathname);

    console.log("base:"+basePath);
    const newPathname = `/${languageCode}${basePath}`;

 console.log("new:"+newPathname);

    return newPathname;
}

export function hasLanguageCodeInPath(currentPathname) {
    const segments = splitCurrentPathIntoSegments(currentPathname);
    return segments.length > 0 && /^[a-z]{2}$/.test(segments[0]);
}

export function getBasePath(currentPathname) {
    const segments = splitCurrentPathIntoSegments(currentPathname);
    console.log("segments:", segments);

    // Determine if the second segment of the pathname is a valid language code
    const hasLanguageCode = hasLanguageCodeInPath(currentPathname);

    // Reconstruct the base path without the language code if it exists
    console.log("language",segments[0]);
    console.log("hasLanguageCode",hasLanguageCode);
    return hasLanguageCode ? `/${segments.slice(1).join('/')}` : `/${segments.join('/')}`;
}


export function matchHomepagePath(currentPathname) {
    return (hasLanguageCodeInPath(currentPathname) && matchPath('/:language?/', currentPathname)) || /^\/?$/.test(currentPathname)
}

export function matchPointPagePath(currentPathname) {

    return (matchPath('/:language?/point/:point', currentPathname)) || matchPath('/:language?/point/:point/page/:page', currentPathname)
}


export function showMultiLingualText(text, altText= null, showFirstLanguage=false)
{
    function isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    if (isObject(text)) {
        if (i18n.language in text && text[i18n.language]) {
            return parse(String(text[i18n.language]));
        }

        // If the languageCode is not found, return the value associated with the first key
        if (altText) {
            return parse(String(altText));
        }

        if (showFirstLanguage) {
            const firstKey = Object.keys(text)[0];
            if (text[firstKey]) {
                return parse(String(text[firstKey]));
            }
        }

        return "";
    }

    return (altText) ? parse(String(altText)) : (text ? parse(String(text)) : "");
}

export function getCountryFlagByLanguage(languageCode)
{
    switch (languageCode.toUpperCase())
    {
        case "NL":
            return <NL/>
        case "EN":
            return <GB/>
        case "DE":
            return <DE/>
        case "FR":
            return <FR/>
        case "FY":
            return (

                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 910 630">
                        <defs>
                            <path id="pomp" d="M0,12A16.143,16.143 0 0,1 -14,-4A7,8 0 0,1 -7,-12A6,8 0 0,1 -1,-5A1,1 0 1,0 1,-5A6,8 0 0,1 7,-12A7,8 0 0,1 14,-4A16.143,16.143 0 0,1 0,12z" fill="#ee3e34" transform="rotate(34.695) scale(4.625)"/>
                        </defs>
                        <rect width="910" height="630" fill="#0155a5"/>
                        <g fill="#fff" transform="scale(130,90)">
                            <path d="M0,3V5L2,7H4z"/>
                            <path d="M1,0H0V1L6,7H7V6z"/>
                            <path d="M3,0H5L7,2V4z"/>
                        </g>
                        <use xlinkHref="#pomp" x="455" y="315"/>
                        <use xlinkHref="#pomp" x="91" y="423"/>
                        <use xlinkHref="#pomp" x="819" y="207"/>
                        <use xlinkHref="#pomp" x="212.333" y="147"/>
                        <use xlinkHref="#pomp" x="697.667" y="483"/>
                        <use xlinkHref="#pomp" x="661.315" y="97.834"/>
                        <use xlinkHref="#pomp" x="248.685" y="532.166"/>
                    </svg>
                );

        default:
            return languageCode
    }
}